import styled from 'styled-components';

export const Section = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  background: #222222;
  box-shadow: 4px 4px 8px 0 rgba(0, 0, 0, 0.25);
  align-self: stretch;
  @media ${({ theme }) => theme.global.mediaQueries.lg} {
   padding: 32px 0px;
  }
`;



export const Left = styled.div`
  display: flex;
  padding-left: 160px;
  justify-content: flex-end;
  align-items: flex-end;
  flex: 1 1 50%;
  min-width: 500px;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    padding-left: 16px;
    padding-right: 16px;
    flex: 1 1 100%;
    min-width: auto;
    justify-content: start;
  }
`;

export const Container = styled.div`
  display: flex;
  max-width: 800px;
  padding: 128px 0px 156px 0px;
  flex-direction: column;
  align-items: start;
  gap: 32px;
  flex: 1 0 0;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    padding: 32px 0px;
    max-width: 1000px;
  }
`;

export const Heading = styled.h2`
  color: white;
  font-size: 48px;
  font-weight: bold;
  align-self: stretch;
  margin: 0;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    font-size: 1.75rem;
  }
`;

export const Text = styled.p`
  align-self: stretch;
  color: white;
  font-size: 18px;
  margin: 0;
`;

export const List = styled.ul`
  display: flex;
  padding: 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  margin: 0;

  li {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    font-size: 18px;
    color: white;

    img {
      display: flex;
      width: 32px;
      height: 32px;
      justify-content: center;
      align-items: center;
    }
  }
`;



export const Button = styled.a`
  display: inline-block;
  background-color: ${({ theme }) => theme.global.colors.primary};
  color: white;
  font-weight: 600;
  padding: 0.75rem 2rem;
  border-radius: 36px;
  text-decoration: none;

  &:hover {
    background-color: #00B453;
  }
`;

export const Right = styled.div`
  display: flex;
  height: 679px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1 50%;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
   display:none;
  }

`;

export const Image = styled.img`
  width: 100%;
  max-width: 800px;
  height: auto;
  object-fit: contain
`;


